export default __webpack_public_path__ + "static/media/instantECardUsagehelpHighlight.3d788134.png";